import Header from "./Header.jsx";
import {useEffect, useState} from "react";
import CheckinSettings from "./wellness-settings-templates/CheckinSettings.jsx";
import RoundsSettings from "./wellness-settings-templates/RoundsSettings.jsx";
import ApiRequester from "./ApiRequester.jsx";
import Button from "./component-assets/Button.jsx";
import Footer from "./Footer.jsx";
import CampusDropDown from "./component-assets/CampusDropDown.jsx";
import EscalationSettings from "./wellness-settings-templates/EscalationSettings.jsx";
import {formFail, formSuccess, handleSubmitActions, iAmHigherAuthority, isBannerPresent} from "../libs.jsx";
import Navigation from "./Navigation.jsx";
import { getSession } from "../services/session";

const WellnessSettings = (props) => {

    let dData = getSession();

    const [careflowv2, setCareflowV2] = useState(dData?.campusData[dData.acnt.toString()]?.careflow_v2);
    const [rounds, setRounds] = useState(dData.campusData[dData.acnt.toString()]?.is_rounding);
    const [checkin, setCheckin] = useState(dData.campusData[dData.acnt.toString()]?.is_resident_checkin);

    // Main Needed data for page
    const [loadState, setLoadState] = useState("init");
    const [wellnessContent, setWellnessContent] = useState(<></>);
    const [campusId, setCampusId] = useState(dData.acnt);
    const [count, setCount] = useState(1);

    // Data collected for sub components
    const [checkinData, setCheckinData] = useState({});
    const [roundsData, setRoundsData] = useState([]);
    const [escData, setEscData] = useState([]);
    const [resGroupData, setResGroupData] = useState([]);
    const [devData, setDevData] = useState([]);
    const [escTypeData, setEscTypeData] = useState([]);
    const [campusData, setCampusData] = useState([]);
    const [groupData, setGroupData] = useState([]);
    const [areaGroupData, setAreaGroupData] = useState([]);

    // Loading state flags.
    const [allLoaded, setAllLoaded] = useState(false);
    const [checkinDataLoaded, setCheckinDataLoaded] = useState(false);
    const [roundsDataLoaded, setRoundsDataLoaded] = useState(false);
    const [checkinLoaded, setCheckinLoaded] = useState(false);
    const [roundsLoaded, setRoundsLoaded] = useState(false);
    const [careflowLoaded, setCareflowLoaded] = useState(false);
    const [devLoaded, setDevLoaded] = useState(false);
    const [escLoaded, setEscLoaded] = useState(true);
    const [escTypeLoaded, setEscTypeLoaded] = useState(false);
    const [campusLoaded, setCampusLoaded] = useState(false)
    const [defEscLoaded, setDefEscLoaded] = useState(false);
    const [groupsLoaded, setGroupsLoaded] = useState(false);
    const [resGroupLoaded, setResGroupLoaded] = useState(false);
    const [areaGroupLoaded, setAreaGroupLoaded] = useState(false);

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0) {
            if (!careflowv2){
                ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt,
                          procedure: "sp_dev_getescalationbycampusid", reqType: "stored"}).then(data => {
                    setEscData(data);
                    setEscLoaded(true)
                });
                ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "att_event_categories",
                                    procedure: "fetchall", reqType: "direct", "read-only": true}).then(data => {
                    setEscTypeData(data);
                    setEscTypeLoaded(true);
                });
                ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "core_campus",
                                procedure: "fetchbyparameter", reqType: "direct"}).then(data => {
                    setCampusData(data);
                    setCampusLoaded(true);
                });
                ApiRequester({reqEndpoint: "myfetch", payload: {device_filter: "",
                                    device_category_filter: "1,2,3,6,7,8,9,10,11,12,15,16,17", campus_id: campusId},
                                    procedure: "sp_dev_getInovonicsDevices", reqType: "stored"}).then(data => {
                    setDevData(data);
                    setDevLoaded(true);
                });
                ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt,
                                procedure: "sp_dev_getgroupsbycampusid", reqType: "stored"}).then(data => {
                    setGroupData(data);
                    setGroupsLoaded(true);
                });
            }else{
                setEscLoaded(true);
                setEscTypeLoaded(true);
                setCampusLoaded(true);
                setDevLoaded(true);
                setGroupsLoaded(true);
            }
            // Checkin items
            if (checkin){
                ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt,
                                procedure: "sp_dev_getcheckinwindow", reqType: "stored"}).then(data => {
                    setCheckinData(() => data);
                    setCheckinDataLoaded(true);
                });
            }else{
                setCheckinDataLoaded(true);
            }
            // Rounds items
            if (rounds){
                ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt,
                                procedure: "sp_dev_getroundswindow", reqType: "stored"}).then(data => {
                    setRoundsData(() => data);
                    setRoundsDataLoaded(true);
                });
            }else{
                setRoundsDataLoaded(true);
            }
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "core_resident_groups",
                                procedure: "fetchbyparameter", reqType: "direct"}).then(data => {
                setResGroupData(data);
                setResGroupLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "core_area_groups",
                                procedure: "fetchbyparameter", reqType: "direct"}).then(data => {
                setAreaGroupData(data);
                setAreaGroupLoaded(true);
            });
            setCount(count => 600);
        }
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        if (loadState === "checkin"){
            setWellnessContent(<CheckinSettings setCount={(value) => setCount(value)}
                                                data={checkinData} resGroupData={() => resGroupData} />);
        }else if (loadState === "rounding"){
            setWellnessContent(<RoundsSettings setCount={(value) => setCount(value)}
                                               data={roundsData} areaGroupData={areaGroupData} />);
        }else if (loadState === "escalation"){
            setWellnessContent(<EscalationSettings setCount={(value) => setCount(value)} groupData={groupData}
                                                   escData={escData} devData={devData} resGroupData={resGroupData}
                                                   escTypeData={escTypeData} campusData={campusData}
                                                   areaGroupData={areaGroupData} />);
        }else if (loadState === "init"){
            setWellnessContent(<p>Wellness settings loading. . .</p>);
        }else{
            setWellnessContent(<>No wellness settings available.</>);
        }
    }, [loadState, escData, roundsData, checkinData]);

    useEffect(() => {
        if (![checkinLoaded, roundsLoaded, careflowLoaded].includes(false)){
            setAllLoaded(true);
            if (loadState === "init"){
                if (checkin){
                    setLoadState("checkin");
                }else if (rounds){
                    setLoadState("rounding");
                }else if (!careflowv2){
                    setLoadState("escalation");
                }else{
                    setLoadState("none");
                }
            }
        }
    }, [checkinLoaded, roundsLoaded, careflowLoaded]);

    useEffect(() => {
        if (![devLoaded, resGroupLoaded, areaGroupLoaded, campusLoaded, escLoaded, groupsLoaded, escTypeLoaded].includes(false)){
            setCareflowLoaded(true);
            if (loadState === "init" && !checkin && !rounds && !careflowv2){
                setLoadState("escalation");
            }
        }
    }, [devLoaded, resGroupLoaded, areaGroupLoaded, campusLoaded, escLoaded, groupsLoaded, escTypeLoaded]);


    useEffect(() => {
        if (![resGroupLoaded, checkinDataLoaded].includes(false)){
            setCheckinLoaded(true);
            if (loadState === "init" && checkin){
                setLoadState("checkin");
            }
        }
    }, [resGroupLoaded, checkinDataLoaded]);

    useEffect(() => {
        if (![areaGroupLoaded, roundsDataLoaded].includes(false)){
            setRoundsLoaded(true);
            if (loadState === "init" && !checkin && rounds){
                setLoadState("rounding");
            }
        }
    }, [areaGroupLoaded, roundsDataLoaded]);

    function syncSubmit(){
        let msg;
        handleSubmitActions("syncSubmit", "syncLoadSubmit");
        ApiRequester({reqEndpoint: "mqtt", Operation: "reboot-server", CampusId: campusId, ClientId: dData.sessionId}).then(data => {
            if(data[0]){
                msg = "Sync triggered, please allow up to 3 minutes for changes to take effect.";
                formSuccess(msg, "syncSubmit", "syncLoadSubmit");
            }
            else{
                msg = "Error syncing, contact support for assistance if error persists.";
                formFail(msg, "syncSubmit", "syncLoadSubmit");
            }
        });
    }

    function restoreSubmit(){
        let msg;
        handleSubmitActions("restoreSubmit", "restoreLoadSubmit");
        ApiRequester({reqEndpoint: "mqtt", Operation: "restore-server", CampusId: campusId, ClientId: dData.sessionId}).then(data => {
            if(data[0]){
                msg = "Restore triggered, please allow up to 3 minutes for changes to take effect.";
                formSuccess(msg, "restoreSubmit", "restoreLoadSubmit");
            }
            else{
                msg = "Error restoring, contact support for assistance if error persists.";
                formFail(msg, "restoreSubmit", "restoreLoadSubmit");
            }
        });
    }

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
            <div>
                {iAmHigherAuthority(99, dData?.role_weight)
                    ? <Button class={"btn btn-primary me-4"} iconClass={"material-icons md-18 md-dark me-2 align-text-bottom"}
                         icon={true} iconSize={"tiny"} iconColor={"#FFFFFF"} iconType={"google"} iconName={"restore_page"}
                         text={"Restore Data"} id={"restoreSubmit"} style={{height: "41.5px", whiteSpace: "nowrap"}} onClick={() => restoreSubmit()}
                         title={"Restore data performs the sync local reboot, however deletes the database file triggering a re-create."} />
                    : <></>}
                <Button class={"btn btn-primary me-4 d-none"} disabled={true} spinner={true} readonly={true} style={{height: "41.5px"}}
                         text={"Restoring..."} id={"restoreLoadSubmit"} />
                <Button class={"btn btn-primary me-4"} iconClass={"material-icons md-18 md-dark me-2 align-text-bottom"}
                         icon={true} iconSize={"tiny"} iconColor={"#FFFFFF"} iconType={"google"} iconName={"cloud_sync"}
                         text={"Sync Local"} id={"syncSubmit"} style={{height: "41.5px", whiteSpace: "nowrap"}} onClick={() => syncSubmit()}
                         title={"Syncs local server with cloud data, will cause the server to go offline momentarily during the process"} />
                <Button class={"btn btn-primary me-4 d-none"} disabled={true} spinner={true} readonly={true} style={{height: "41.5px"}}
                         text={"Syncing..."} id={"syncLoadSubmit"} />
            </div>
            <CampusDropDown campusId={campusId} setCampusId={(item) => setCampusId(item)} setCount={(item) => setCount(item)} pageAction={(e) => {
                if (careflowv2 !== dData?.campusData[e.target.value]?.careflow_v2 && (loadState === "escalation" || [dData?.campusData[e.target.value]?.is_resident_checkin, dData?.campusData[e.target.value]?.is_rounding].every((item) => {return item === 0}))){
                    window.location.href = "/settings/careflow";
                }else if (dData?.campusData[campusId.toString()]?.is_cloud !== dData?.campusData[e.target.value]?.is_cloud){
                    window.location.reload();
                }else{
                    setCareflowV2(dData?.campusData[e.target.value]?.careflow_v2);
                    setCheckin(dData?.campusData[e.target.value]?.is_resident_checkin);
                    setRounds(dData?.campusData[e.target.value]?.is_rounding);
                    setLoadState("init");
                    setAllLoaded(false);
                    setCheckinLoaded(false);
                    setCheckinDataLoaded(false);
                    setRoundsDataLoaded(false);
                    setRoundsLoaded(false);
                    setDefEscLoaded(false);
                    setEscLoaded(false);
                    setEscTypeLoaded(false);
                    setCampusLoaded(false);
                    setGroupsLoaded(false);
                    setAreaGroupLoaded(false);
                    setResGroupLoaded(false);
                }
            }} />
        </div>
    )

    return (
        <>
            <Navigation/>
            <div className={"main-content"}>
                <Header preTitle={"Settings"} Title={"Wellness Settings"} content={headerContent}/>
                <div className={"container-fluid"}>
                    <div className={`row align-items-center ${isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}`}
                         style={{backgroundColor: "var(--color-bg-primary)"}}>
                        <div className={"col"}>
                            <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                                {checkin
                                    ?   <li key={"set-checkin"} className={"nav-item"}>
                                            <Button text={"Check-in"} class={loadState === "checkin" ? "nav-link active" : "nav-link"}
                                                    onClick={() => setLoadState("checkin")}
                                                    disabled={!checkinLoaded} spinner={!checkinLoaded} />
                                        </li>
                                    :   <></>
                                }
                                {rounds
                                    ?   <li key={"set-rounds"} className={"nav-item"}>
                                            <Button text={"Rounds"} class={loadState === "rounding" ? "nav-link active" : "nav-link"}
                                                    disabled={!roundsLoaded} spinner={!roundsLoaded}
                                                    onClick={() => setLoadState("rounding")} />
                                        </li>
                                    :   <></>
                                }
                                {!careflowv2
                                    ?   <li key={"set-escalation"} className={"nav-item"}>
                                            <Button text={"Careflow"} class={loadState === "escalation" ? "nav-link active" : "nav-link"}
                                                    disabled={!allLoaded} spinner={!allLoaded}
                                                    onClick={() => setLoadState("escalation")} />
                                        </li>
                                    :   <></>
                                }
                            </ul>
                        </div>
                    </div>
                    {wellnessContent}
                </div>
                <div className={"footer-spacer"}></div>
                <Footer left={loadState === "escalation" ?
                    <h3 style={{textAlign: "left"}}>* The PalCare alert system is ENABLED by default. The system
                        broadcasts an emergency alert to users of the PalMobile application.
                        Each resident device is ACTIVE throughout the 24/7 cycle, every day of the week. To alter the
                        system settings for generation of the alerts,
                        please use the attached screens</h3> : <></>}/>
            </div>
        </>
    );
};

export default WellnessSettings;